import { apiClient } from './client';
import type { QueryParams } from './client';
import type {
  ApiEnvelope,
  PaginatedData,
  Parametro,
  ParametroBody,
  ParametrosListParams,
  GenerateUploadLink,
} from './types';

// ── Parámetros ───────────────────────────────────────────────────────────────

/**
 * Listar parámetros públicos activos (no requiere autenticación).
 *
 * GET /api/v1/parametro-publicos/
 */
export function listarParametrosPublicos() {
  return apiClient.get<ApiEnvelope<Parametro[]>>(
    '/api/v1/parametro-publicos/',
    undefined,
    true,
  );
}

/**
 * Listar parámetros con paginación y filtros.
 *
 * GET /api/v1/parametro/
 */
export function listarParametros(params?: ParametrosListParams) {
  return apiClient.get<ApiEnvelope<PaginatedData<Parametro>>>(
    '/api/v1/parametro/',
    params as QueryParams,
  );
}

/**
 * Ver detalle de un parámetro.
 *
 * GET /api/v1/parametro/{id}/
 */
export function verParametro(id: string) {
  return apiClient.get<ApiEnvelope<Parametro>>(`/api/v1/parametro/${id}/`);
}

/**
 * Crear un parámetro.
 *
 * POST /api/v1/parametro/
 */
export function crearParametro(data: ParametroBody) {
  return apiClient.post<ApiEnvelope<Parametro>>('/api/v1/parametro/', data);
}

/**
 * Actualizar un parámetro existente.
 *
 * PUT /api/v1/parametro/{id}/
 */
export function actualizarParametro(id: string, data: ParametroBody) {
  return apiClient.put<ApiEnvelope<Parametro>>(
    `/api/v1/parametro/${id}/`,
    data,
  );
}

/**
 * Eliminar un parámetro (operación deshabilitada en el backend, retorna 405).
 *
 * DELETE /api/v1/parametro/{id}/
 */
export function eliminarParametro(id: string) {
  return apiClient.delete<ApiEnvelope<null>>(`/api/v1/parametro/${id}/`);
}

// ── MinIO ────────────────────────────────────────────────────────────────────

/**
 * Generar URL prefirmada para subir un archivo a MinIO.
 *
 * POST /api/v1/generar-enlace-subida-minio/
 */
export function generarEnlaceSubidaMinio(data: GenerateUploadLink) {
  return apiClient.post<ApiEnvelope<string>>(
    '/api/v1/generar-enlace-subida-minio/',
    data,
  );
}
